import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { TrackerService } from '../../services/tracker.service';
import { UiService } from '../../../../core/services/core.ui.service';
import { StateService } from '@uirouter/angular';

import * as _ from 'lodash';
import {ProjectModel} from "../../../../core/services/project.model.service";

@Component({
  selector: 'tracker-add',
  template: require('./tracker.add.component.html')
})
export class TrackerAddComponent implements OnInit, OnChanges {
  @Input() project: any;
  @Input() siteConfig: any;

  tracker: any = null;
  trackerType = 2;
  trackerTypes = { 'Task Tracker': 2, 'Support Tracker': 3 };
  hostName: string;
  roles: any[] = [];
  selectedRoles: Array<any> = [];
  rolesLabel: string | false = false;


  constructor(
    private trackerService: TrackerService,
    private uiService: UiService,
    protected stateService: StateService,
    private projectModel: ProjectModel
  ) {
  }

  ngOnInit() {
    // Initialize if inputs are already available
    if (this.project && this.siteConfig) {
      this.initializeComponent();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Initialize when both inputs become available
    if ((changes.project || changes.siteConfig) && this.project && this.siteConfig && !this.tracker) {
      this.initializeComponent();
    }
  }

  private initializeComponent() {
    this.hostName = _.get(this.siteConfig, 'hostName', '');
    this.init();

    this.projectModel.loadProjectRoles(this.stateService.params.unixName)
        .then((data: any) => {
          this.roles =  data;
    });
  }
  protected hasRole(role: any): boolean {
    return _.find(this.selectedRoles, (r) => r.id === role.id) !== undefined;
  }
  protected toggleRole(role: any): void {
    if (!Array.isArray(this.selectedRoles)) {
      this.selectedRoles = [];
    }
    const index = this.selectedRoles.findIndex(r => r.id === role.id);

    if (index > -1) {
      this.selectedRoles = this.selectedRoles.filter(r => r.id !== role.id);
    } else {
      this.selectedRoles = _.concat(this.selectedRoles, role);
    }

    this.rolesLabel = this.getRolesLabel();
    this.tracker.autoAssignToRoles =  _.get(this.tracker, 'autoAssignToRoles', {});
  }
  private getRolesLabel(): string | false {
    const len = _.get(this.selectedRoles, 'length', 0);
    if (len === 0) {
      return false;
    }
    if (len < 4) {
      return _.map(this.selectedRoles, 'roleName').join(',');
    }
    return `${this.selectedRoles.length} roles`;
  }

  setConfigValue(path: string, value: any) {
    if (value === undefined || value === _.get(this, path)) return false;
    _.set(this, path, value);
  }

  toggleBoolean(path: string) {
    if (!_.has(this.tracker, path) || typeof _.get(this.tracker, path) !== 'boolean') {
      return;
    }
    const val = _.get(this.tracker, path);
    _.set(this.tracker, path, !val);
  }

  toggleYN(path: string) {
    if (!_.has(this.tracker, path)) {
      return;
    }
    let val = _.get(this.tracker, path);
    val = (val === 'Y') ? 'N' : 'Y';
    _.set(this.tracker, path, val);
  }

  saveTracker() {
    this.tracker.autoAssignToRoles = this.selectedRoles;
    this.trackerService.create(this.tracker)
      .then((ret: any) => {
        this.stateService.go('home.project.summary.admin.tracker', this.stateService.params, { reload: true, notify: true });
      }, (err: any) => {
          this.uiService.message.showError(
            'There was an error processing your Tracker submission.',
            'Add new Tracker');
      });
  }

  private init() {
    this.tracker = {
      id: 0,
      project: this.project?.id,
      emailAllUpdates: 'N',
      emailAddress: '',
      emailAlias: '',
      isPublic: 'N',
      restrictBrowse: 'N',
      submitInstructions: '',
      browseInstructions: '',
      autoresponseInstructions: '',
      trackerName: '',
      description: '',
      trackerType: this.trackerType,
      autoAssignToRoles: {},
      settings: {
        showDependenciesTab: 'N',
        showDuplicatesTab: 'N',
        showAssociationsTab: 'N',
        showTimeTrackingTab: 'N',
        showTagsTab: 'N',
        emailAllUpdates: 'N'
      },
      errors: {},
      errorTypes: {
        length: 'Bad length.',
        required: 'Required field.',
        Invalid: 'Use lowercase letters, numbers or underscore.',
        Numeric: 'Numeric names not allowed.',
        Exists: 'Already registered.'
      }
    };
  }
}
